import {createTRPCProxyClient, httpBatchLink} from "@trpc/client"
import superjson from "superjson"

import {API_BASE_URL} from "@frontend/env"
import type {AppRouter} from "@ri2/app/server/routers/_app"

import {trpc} from "./trpc"

const trpcLinks = [
  httpBatchLink({
    url: `${API_BASE_URL}/trpc`,
    transformer: superjson,
  }),
]

export const TRPC_CLIENT = trpc.createClient({
  links: trpcLinks,
})

export const TRPC_PROXY_CLIENT = createTRPCProxyClient<AppRouter>({
  links: trpcLinks,
})
